// src/services/staffDocs.ts
// -------------------------
// db-208: pure rules for documents attached to a Zephyr Staff record (the PRIVATE,
// SuperUser-only 'staff-docs' bucket). The bucket itself enforces the same 5 MB
// limit and PDF / JPEG / PNG whitelist server-side; these checks give a friendly
// message before the upload is attempted.

export const STAFF_DOC_MAX_BYTES = 5 * 1024 * 1024;

const TYPE_BY_EXTENSION: Record<string, string> = {
  pdf: "application/pdf",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
};

// The content type to upload with, worked out from the file EXTENSION. Windows can
// report a blank or non-standard type (e.g. "image/jpg") that the bucket would
// reject, so the browser's reported type is not trusted. null = not allowed.
export function staffDocContentType(file: { name?: string } | null | undefined): string | null {
  const m = /\.([a-z0-9]+)$/i.exec(file?.name || "");
  if (!m) return null;
  return TYPE_BY_EXTENSION[m[1].toLowerCase()] ?? null;
}

// "" when the file may be uploaded, otherwise the message to show.
export function staffDocError(file: { name?: string; size?: number } | null | undefined): string {
  if (!file) return "No file chosen.";
  if (!staffDocContentType(file)) {
    return "Only PDF, JPG or PNG files can be uploaded. Please save the file in one of those formats.";
  }
  if ((file.size ?? 0) > STAFF_DOC_MAX_BYTES)
    return "That file is over 5 MB. Please make it smaller.";
  if ((file.size ?? 0) === 0) return "That file is empty.";
  return "";
}

// Strip the "<timestamp>-" upload prefix from a stored name for display.
export function staffDocDisplayName(name: string | null | undefined): string {
  return String(name || "").replace(/^\d+-/, "");
}
